import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/not-protected')({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>This is not a protected page</div>;
}
